import React, {useEffect, useState} from "react"
import { createPortal } from "react-dom"
import {connect} from "react-redux"
import "pages/Styles/UIKit_v2.sass"
import "pages/Styles/OrderInfo.sass"
import {httpClient} from "../../funcs";
import notifyUser, {notifyAboutError} from "../../methods/notifyUser";
import {loadSelf} from "../../methods/loadSelf";
import Popup from "../../components/Popup";
import CustomTextField from "../../components/elements/TextField";
import {CircularProgress, useMediaQuery} from "@mui/material";
import {validate} from "../../validate";
import {mobileMaxWidthMediaQuery} from "../../methods/utils";
import OrderInfo from "../Tariffs/OrderInfo";
import {FileDropzone} from "../../components/FileDropzone";
import moment from "moment";


type Props = {
    close: () => void,
    onCollectBonus: Function,
    onBillCreated?: Function,  // Callback для уведомления о создании счета
    onLoadTariffs?: Function, // Callback для обновления тарифов
    onPaymentProofUploaded?: (items?: any[]) => void, // Callback для закрытия попапа после загрузки платежного поручения
    $store: any,
    $commitToStore: Function,
    items: any[] // Список товаров для оплаты
}

let RequestBillPopupV2: any = function RequestBillPopupV2(props: Props) {
    const isMobile = useMediaQuery(mobileMaxWidthMediaQuery)
    const normalizeTaxIdInput = (v: string) => v.replace(/\D/g, "").slice(0, 12)
    const [taxId, setTaxId] = useState(normalizeTaxIdInput(props.$store.userSession?.tax_id || ""))
    const [email, setEmail] = useState(props.$store.userSession?.email || "")
    const [taxIdError, setTaxIdError] = useState("")
    const [emailError, setEmailError] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [billCreated, setBillCreated] = useState(false)
    const [billData, setBillData] = useState<any>(null)
    const [paymentProof, setPaymentProof] = useState<string>("")

    async function requestBill() {
        try {
            setIsLoading(true)
            
            const requestData = {
                'tax_id': taxId,
                'email': email,
                'items': props.items
            }
            
            const {data} = await httpClient.post('/request-bill-v2', requestData)
            
            // Сохраняем данные счета и показываем форму загрузки
            setBillData({
                _id: data.bill_id,
                pdf_url: data.pdf_url,
                invoice_number: data.invoice_number || 'Н/Д',
                created_at: new Date().toISOString()
            })
            setBillCreated(true)
            notifyUser(props, 'Счет успешно создан', 'Загрузите платежное поручение после оплаты')
            if (props.onBillCreated) {
                props.onBillCreated()
            }
            // НЕ вызываем onBillCreated здесь, так как пользователь должен остаться в попапе
            // для скачивания счета и загрузки платежного поручения
        } catch (error) {
            notifyAboutError(props, error)
        } finally {
            setIsLoading(false)
        }
    }

    // Валидация ИНН при изменении
    useEffect(() => {
        if (taxId) {  // Проверяем только если поле не пустое
            const error = validate('ruTaxId', taxId, 'ИНН организации')
            setTaxIdError(error || "")
        } else {
            setTaxIdError("")
        }
    }, [taxId])

    // Валидация email при изменении
    useEffect(() => {
        if (email) {  // Проверяем только если поле не пустое
            const error = validate('email', email)
            setEmailError(error || "")
        } else {
            setEmailError("")
        }
    }, [email])


    const handleFileUpload = async (file: any) => {
        if (file) {
            const reader = new FileReader()
            reader.onloadend = async () => {
                const base64String = (reader.result as string).split(',')[1]
                setPaymentProof(base64String)
                
                try {
                    setIsLoading(true)
                    await httpClient.post('/upload-payment-proof-v2', {
                        payment_proof: base64String,
                        bill_id: billData._id,
                        file_type: file.type
                    })
                    
                    // Обновляем баланс пользователя после успешной загрузки
                    await loadSelf(props)
                    
                    // Обновляем тарифы после успешной загрузки платежного поручения
                    if (props.onLoadTariffs) {
                        await props.onLoadTariffs()
                    }
                    
                    // Очищаем корзину

                    
                    // Вызываем callback для закрытия попапа и показа попапа настройки шаблона если нужно
                    if (props.onPaymentProofUploaded) {
                        props.onPaymentProofUploaded(props.items)
                    } else {
                        props.close()
                    }
                    
                    notifyUser(props, 'Платежное поручение загружено', 'Тариф будет активирован после проверки')
                } catch (error) {
                    notifyAboutError(props, error)
                } finally {
                    setIsLoading(false)
                }
            }
            reader.readAsDataURL(file)
        }
    }

    // Функция для обработки закрытия попапа с проверкой состояния
    const handleClose = async () => {
        // Если счет создан и платежное поручение загружено, выполняем необходимые действия
        if (billCreated && paymentProof) {
            // Обновляем тарифы
            if (props.onLoadTariffs) {
                await props.onLoadTariffs()
            }
        }
        
        console.log('handleClose', billCreated, paymentProof)
        // Закрываем попап
        props.close()
    }

    // Форма валидна если:
    // 1. Есть данные корзины
    // 2. ИНН не пустой и без ошибок
    // 3. Email не пустой и без ошибок
    const isFormValid = props.items && 
        taxId && !taxIdError && 
        email && !emailError

    const popup = (
        <Popup onClose={handleClose}>
            <div
                style={{
                    width: isMobile ? '100%' : '',
                    maxWidth: '100%',
                }}
            >
                <div className="H3_21_v2 text-center">
                    {billCreated ? 'Ожидание оплаты' : 'Заказ счета на оплату'}
                </div>

                {/* Информация о заказе */}
                <OrderInfo showTitle={true} cart={props.items} />

                {billCreated && billData && (
                    <>
                        <div className="form-field">
                            <div className="Body_16_v2_secondary" style={{marginTop: "20px", marginBottom: "10px"}}>Информация о счете</div>
                            <div>Номер счета: {billData.invoice_number}</div>
                            <div>Создан: {moment(billData.created_at).format('DD.MM.YYYY')}</div>
                        </div>

                        {billData.pdf_url && (
                            <div className="form-field">
                                <div className="Body_16_v2_secondary" style={{marginBottom: "10px"}}>
                                    Счет отправлен на указанную почту.
                                    Вы также можете скачать его прямо сейчас:
                                </div>
                                <button
                                    className="new action-button secondary"
                                    onClick={() => window.open(billData.pdf_url, '_blank')}
                                >
                                    <span className="button-text">Скачать счет</span>
                                </button>
                            </div>
                        )}

                        <div className="form-field" style={{marginTop: "20px"}}>
                            <div className="Body_16_v2_secondary" style={{
                                padding: "15px",
                                background: "#FFF3DC",
                                borderRadius: "10px",
                                color: "#B38B2C"
                            }}>
                                <div style={{fontWeight: 600, marginBottom: "5px"}}>
                                    Важно!
                                </div>
                                После оплаты счета необходимо загрузить платежное поручение для подтверждения платежа.
                                Тариф будет активирован после проверки платежного поручения.
                            </div>
                        </div>

                        <hr className="divider" style={{margin: "20px 0"}} />
                        
                    </>
                )}

                {!billCreated && (
                    <>
                        <div>
                            <div className="Body_16_v2_secondary" style={{marginTop: "20px", marginBottom: "10px"}}>ИНН организации</div>
                            <CustomTextField
                                value={taxId}
                                error={!!taxIdError}
                                helperText={taxIdError}
                                inputProps={{ inputMode: 'numeric', autoComplete: 'off', maxLength: 12 }}
                                onKeyPress={(e: any) => {
                                    if(e.key === 'Enter')
                                        e.preventDefault()
                                }}
                                placeholder={"Введите ИНН"}
                                onChange={({target: {value}}: any) => {
                                    setTaxId(normalizeTaxIdInput(value))
                                }}
                            />
                        </div>

                        <div>
                            <div className="Body_16_v2_secondary" style={{marginTop: "20px", marginBottom: "10px"}}>Email для получения счета</div>
                            <CustomTextField
                                value={email}
                                error={!!emailError}
                                helperText={emailError}
                                onKeyPress={(e: any) => {
                                    if(e.key === 'Enter')
                                        e.preventDefault()
                                }}
                                placeholder={"Введите email"}
                                onChange={({target: {value}}: any) => {
                                    setEmail(value)
                                }}
                            />
                        </div>

                        <div className="flex-center" style={{marginTop: "16px"}}>
                            <button
                                className="new action-button primary"
                                disabled={isLoading || !isFormValid}
                                onClick={async () => {
                                    await requestBill()
                                }}
                            >
                                <div className="buttonsContainer">
                                    {isLoading && 
                                        <CircularProgress 
                                            size={20} 
                                            style={{
                                                color: 'white'
                                            }}
                                        />
                                    }
                                    <div className="button-text">
                                        Запросить счет на заказ
                                    </div>
                                </div>
                            </button>
                        </div>
                    </>
                )}

                {billCreated && !paymentProof && (
                    <div className="form-field">
                        <div className="Body_16_v2_secondary" style={{marginBottom: "5px"}}>Загрузить платежное поручение</div>
                        <FileDropzone 
                            onFilesSelect={(files) => {
                                if (files?.[0]) {
                                    handleFileUpload(files[0])
                                }
                            }}
                            accept=".pdf,image/*"
                            text="Перетащите сюда платежное поручение или воспользуйтесь кнопкой"
                            buttonText="Выбрать файл"
                        />
                    </div>
                )}
                
                {billCreated && paymentProof && (
                    <div className="form-field">
                        <div className="Body_16_v2_secondary" style={{color: 'green'}}>
                            Платежное поручение загружено
                        </div>
                        <div>Ожидайте активации тарифа</div>
                    </div>
                )}

                {/* Кнопка для закрытия попапа */}
                <div className="flex-center" style={{marginTop: "16px"}}>
                    <button
                        className="new action-button secondary"
                        onClick={handleClose}
                    >
                        <span className="button-text">Закрыть</span>
                    </button>
                </div>
            </div>
        </Popup>
    )

    // Важно: этот попап часто открывается поверх попапа корзины.
    // Если рендерить его внутри вложенного DOM-дерева, на мобилке он может "резаться" стилями родителя.
    // Портал в document.body гарантирует корректный полноэкранный оверлей.
    return typeof document !== 'undefined' ? createPortal(popup, document.body) : popup
}

RequestBillPopupV2 = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(RequestBillPopupV2)

export default RequestBillPopupV2
